import type { ComponentProps } from 'react';
import React from 'react';
import { cn } from '../../lib/utils';

type AppViewportProps = ComponentProps<'div'>;

/**
 * AppViewport
 * A generic app root wrapper responsible for page spacing and viewport sizing.
 * Intentionally does NOT manage scrolling.
 */
function AppViewport({ className, ...props }: AppViewportProps) {
	return (
		<div
			className={cn(
				'w-full px-12 tablet:px-32 laptop:px-48 desktop:px-0 desktop:mx-auto desktop:w-[var(--desktop-layout-width)] flex flex-col',
				className
			)}
			data-testid="app-viewport"
			{...props}
		/>
	);
}

export { AppViewport };
